import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InfoStatusEnum } from '../../../enums/infoStatus.enum'

@Component({
  selector: 'app-soc-text-field',
  templateUrl: './soc-text-field.component.html',
  styleUrls: ['./soc-text-field.component.scss']
})
export class SocTextFieldComponent implements OnInit {

  @Input() label: string | null;
  @Input() alertLabel: string | null;
  @Input() addOn: string | null = "-";
  @Input() status: InfoStatusEnum = InfoStatusEnum.Info;
  @Input() placeholder: string | null = "";
  @Input() input: any | null = "";
  @Input() rowsInput: string |null | undefined = "2";
  @Output() inputChange = new EventEmitter<any>();

  public infoStatusEnum = InfoStatusEnum;

  constructor() { }

  ngOnInit(): void {
  }

}
